/** Skraca kolejne numery stron do zakresów, zachowując przerwy między nimi. */
export function pageRanges(pages) {
  const numbers = [
    ...new Set(pages.filter((page) => Number.isInteger(page) && page > 0)),
  ].sort((a, b) => a - b);
  const ranges = [];
  for (let i = 0; i < numbers.length; i++) {
    const start = numbers[i];
    let end = start;
    while (numbers[i + 1] === end + 1) end = numbers[++i];
    ranges.push(start === end ? `${start}` : `${start}–${end}`);
  }
  return ranges.join(", ");
}
